import { render, staticRenderFns } from "./SignPad.vue?vue&type=template&id=20960f84&scoped=true&"
import script from "./SignPad.vue?vue&type=script&lang=js&"
export * from "./SignPad.vue?vue&type=script&lang=js&"
import style0 from "./SignPad.vue?vue&type=style&index=0&id=20960f84&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20960f84",
  null
  
)

export default component.exports